import { Dropdown } from '@Components/Dropdown';
import { Checkbox } from '@Components/FormCheck';
import { Placement, Size } from '@Components/designConstants';
import { AssetSeries, COLOR_MODE_LABEL, ColorMode, ColorModeType } from './metaHackathon-constants';

const COLOR_MODE_OPTIONS: { value: ColorModeType; label: string }[] = (
  Object.values(ColorMode) as ColorModeType[]
).map(value => ({ value, label: COLOR_MODE_LABEL[value] }));

interface ChartColorControlsProps {
  series: AssetSeries[];
  colorMode: ColorModeType;
  onColorModeChange: (mode: ColorModeType) => void;
  assetColors: Map<string, string>;
  hiddenAssetIds: Set<string>;
  onToggleAsset: (assetId: string) => void;
}

export const ChartColorControls = ({
  series,
  colorMode,
  onColorModeChange,
  assetColors,
  hiddenAssetIds,
  onToggleAsset
}: ChartColorControlsProps) => (
  <div className='chart-color-controls'>
    <Dropdown
      overlayPlacement={Placement.RIGHT}
      label='Color by'

      size={Size.SM}
      value={colorMode}
      onChange={onColorModeChange}
      options={COLOR_MODE_OPTIONS}
    />
    <div className='ad-group-list'>
      {series.map(asset => (
        <div key={asset.assetId} className='ad-group-row'>
          <span className='swatch' style={{ backgroundColor: assetColors.get(asset.assetId) }} />
          <Checkbox
            id={`ad-group-${asset.assetId}`}
            label={asset.assetName}
            checked={!hiddenAssetIds.has(asset.assetId)}
            onChange={() => onToggleAsset(asset.assetId)}
          />
        </div>
      ))}
    </div>
  </div>
);
